"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
const logger_1 = require("@almservices-cl/logger");
class GraphqlClient {
    constructor(client, logger) {
        this.fetch = async (operationName, query, variables) => {
            this.logger.log(`Executing Graphql Operation: "${operationName}"`);
            const response = await this.client.post("/graphql", {
                query,
                operationName,
                variables,
            });
            if (response.errors) {
                throw new exception_1.DomainException("Request Failed: " +
                    response.errors.map(({ message }) => message).join(", "));
            }
            return response.data;
        };
        this.client = client;
        this.logger = logger || new logger_1.NullLogger();
    }
}
exports.default = GraphqlClient;
//# sourceMappingURL=GraphqlClient.js.map